import React, { useEffect, useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { SITE_CONFIG } from '../../constants/siteConfig.js';
import { supabase } from '../../lib/supabase.js';
import WebTopBar from '../components/WebTopBar.js';

const VALID = new Set(['aviso', 'privacidad', 'terminos', 'cookies']);

const TITLES = {
  aviso: 'Aviso legal',
  privacidad: 'Política de privacidad',
  terminos: 'Términos y condiciones de uso',
  cookies: 'Política de cookies',
};

function P({ children }) {
  return <p style={{ margin: '0 0 14px', color: 'rgba(255,255,255,0.82)', lineHeight: 1.65 }}>{children}</p>;
}

function H3({ children }) {
  return (
    <h3 style={{ color: C.gold, fontSize: '1.02rem', fontWeight: 800, margin: '22px 0 10px', letterSpacing: '-0.02em' }}>{children}</h3>
  );
}

function BodyAviso() {
  const { nombre, dominio, urlPublica, emailLegal, titular, ciudad, paisTitular, fechaActualizacionLegal } = SITE_CONFIG;
  return (
    <>
      <P>
        En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa de los datos identificativos del titular del sitio web accesible en{' '}
        <strong style={{ color: '#fff' }}>{urlPublica}</strong> (en adelante, «{nombre}»).
      </P>
      <H3>Datos del titular</H3>
      <P>
        <strong style={{ color: '#fff' }}>Titular:</strong> {titular}
        <br />
        <strong style={{ color: '#fff' }}>Domicilio:</strong> {ciudad}, {paisTitular}
        <br />
        <strong style={{ color: '#fff' }}>Correo electrónico:</strong>{' '}
        <a href={`mailto:${emailLegal}`} style={{ color: C.gold }}>
          {emailLegal}
        </a>
        <br />
        <strong style={{ color: '#fff' }}>Dominio:</strong> {dominio}
      </P>
      <H3>Objeto</H3>
      <P>
        {nombre} es una plataforma digital dedicada al intercambio y comercialización de música en formato físico entre usuarios. La mera navegación y el uso de los servicios implican la aceptación de los términos publicados en su día, sin perjuicio de que ciertas
        funcionalidades requieran registro y aceptación expresa adicional.
      </P>
      <H3>Propiedad intelectual e industrial</H3>
      <P>
        Los contenidos, diseño, marcas, logotipos y demás elementos del sitio son titularidad de {nombre} o de terceros que han autorizado su uso. Queda prohibida su reproducción, distribución o transformación sin autorización.
      </P>
      <H3>Responsabilidad</H3>
      <P>
        {nombre} actúa como intermediario tecnológico entre compradores y vendedores. Los anuncios y productos publicados son responsabilidad de los usuarios. Se aplican las limitaciones legales en materia de contenidos ilícitos conforme a la LSSI-CE y normativa
        aplicable.
      </P>
      <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.45)', margin: '24px 0 0', lineHeight: 1.65 }}>Última revisión: {fechaActualizacionLegal}.</p>
    </>
  );
}

function BodyPrivacidad() {
  const { nombre, dominio, emailLegal, emailContacto, emailSoporte, titular, fechaActualizacionLegal } = SITE_CONFIG;
  return (
    <>
      <P>
        El responsable del tratamiento de los datos personales obtenidos a través de {dominio} es <strong style={{ color: '#fff' }}>{titular}</strong> (plataforma {nombre}). En materia de privacidad:{' '}
        <a href={`mailto:${emailLegal}`} style={{ color: C.gold }}>
          {emailLegal}
        </a>
        . Consultas generales:{' '}
        <a href={`mailto:${emailContacto}`} style={{ color: C.gold }}>
          {emailContacto}
        </a>
        . Incidencias de cuenta:{' '}
        <a href={`mailto:${emailSoporte}`} style={{ color: C.gold }}>
          {emailSoporte}
        </a>
        .
      </P>
      <H3>Finalidades y base legal</H3>
      <P>
        Tratamos los datos que nos facilitas para gestionar el registro y la cuenta, prestar el servicio de marketplace (publicación de anuncios, mensajería, notificaciones operativas), mejorar la seguridad y el cumplimiento legal, y —solo si lo autorizas— enviar
        comunicaciones comerciales.
      </P>
      <P>La base legal puede ser la ejecución de un contrato o medidas precontractuales, el consentimiento, el interés legítimo (seguridad, mejora del servicio) u obligación legal, según el tratamiento concreto.</P>
      <H3>Conservación</H3>
      <P>Conservaremos los datos el tiempo necesario para las finalidades indicadas y para atender posibles responsabilidades legales. Tras ello, serán bloqueados o suprimidos conforme a la normativa.</P>
      <H3>Destinatarios</H3>
      <P>
        Podremos comunicar datos a proveedores que actúen en nuestro nombre (p. ej. alojamiento, autenticación, mensajería, analítica agregada) con las garantías exigidas por el RGPD. No vendemos tus datos personales a terceros.
      </P>
      <H3>Derechos</H3>
      <P>
        Puedes ejercer los derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a {emailLegal}, adjuntando copia de un documento identificativo. También puedes reclamar ante la Agencia Española de Protección de
        Datos (www.aepd.es).
      </P>
      <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.45)', margin: '24px 0 0', lineHeight: 1.65 }}>Última revisión: {fechaActualizacionLegal}.</p>
    </>
  );
}

function BodyTerminos() {
  const { nombre, dominio, emailSoporte, fechaActualizacionLegal } = SITE_CONFIG;
  return (
    <>
      <P>
        El uso de los servicios de {nombre} en {dominio} implica que has leído y aceptas estas condiciones. Si no estás de acuerdo, no utilices la plataforma.
      </P>
      <H3>Servicio</H3>
      <P>{nombre} ofrece un entorno para publicar, descubrir y contactar respecto a artículos de música física. La transacción material (pago, envío y garantías) puede ser responsabilidad directa entre usuarios hasta que existan flujos de pago integrados.</P>
      <H3>Cuenta</H3>
      <P>Eres responsable de la veracidad de tus datos y de la confidencialidad de tus credenciales. Debes ser mayor de edad legal o actuar con la autorización de quien ostente la patria potestad o tutela cuando corresponda.</P>
      <H3>Conducta y contenidos</H3>
      <P>Queda prohibido el uso fraudulento, la suplantación, la publicación de contenidos ilícitos o que infrinjan derechos de terceros, y cualquier actividad que comprometa la seguridad del sitio o de otros usuarios.</P>
      <H3>Plazos de entrega en el marketplace</H3>
      <P>
        En compras con partner (tienda verificadora o punto DreamVinyl) o envío directo, la plataforma muestra plazos orientativos en días laborables (habitualmente 2–3 días para entregas al partner y verificación; 2–5 días para envío directo vendedor-comprador). Vendedores y partners deben actuar dentro de esos plazos; el comprador debe confirmar la recepción cuando reciba el artículo. El detalle contractual figura en la documentación legal publicada (sección de transacciones y plazos).
      </P>
      <H3>Limitación de responsabilidad</H3>
      <P>
        {nombre} procura mantener el servicio disponible, pero no garantiza ausencia de interrupciones. En la medida permitida por la ley, no seremos responsables por daños indirectos o lucro cesante derivados del uso de la plataforma.
      </P>
      <H3>Modificaciones</H3>
      <P>
        Podremos actualizar estos términos. La versión vigente será la publicada en esta página. Para dudas:{' '}
        <a href={`mailto:${emailSoporte}`} style={{ color: C.gold }}>
          {emailSoporte}
        </a>
        .
      </P>
      <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.45)', margin: '24px 0 0', lineHeight: 1.65 }}>Última revisión: {fechaActualizacionLegal}.</p>
    </>
  );
}

function BodyCookies() {
  const { nombre, dominio, fechaActualizacionLegal, emailLegal } = SITE_CONFIG;
  return (
    <>
      <P>
        {nombre} utiliza cookies y tecnologías similares en {dominio} para el funcionamiento técnico del sitio, preferencias y, con tu consentimiento cuando sea preciso, analítica o personalización.
      </P>
      <H3>Tipos</H3>
      <P>
        <strong style={{ color: '#fff' }}>Necesarias:</strong> permiten la navegación y funciones básicas (p. ej. sesión, seguridad).
        <br />
        <strong style={{ color: '#fff' }}>Preferencias:</strong> recuerdan elecciones (idioma, filtros).
        <br />
        <strong style={{ color: '#fff' }}>Estadística / marketing:</strong> solo si las aceptas explícitamente cuando la configuración lo requiera.
      </P>
      <H3>Gestión</H3>
      <P>Puedes retirar o modificar tu consentimiento borrando las cookies del navegador o desde el panel de preferencias cuando esté disponible. Consulta la ayuda de tu navegador para bloquear o eliminar cookies.</P>
      <H3>Más información</H3>
      <P>
        Para ejercer derechos relacionados con datos personales, consulta la política de privacidad o escribe a{' '}
        <a href={`mailto:${emailLegal}`} style={{ color: C.gold }}>
          {emailLegal}
        </a>
        .
      </P>
      <p style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.45)', margin: '24px 0 0', lineHeight: 1.65 }}>Última revisión: {fechaActualizacionLegal}.</p>
    </>
  );
}

const BODIES = {
  aviso: BodyAviso,
  privacidad: BodyPrivacidad,
  terminos: BodyTerminos,
  cookies: BodyCookies,
};

function LegalProvisionalNotice() {
  if (!SITE_CONFIG.legalTextsProvisional) return null;
  return (
    <div
      style={{
        marginBottom: 20,
        padding: '12px 14px',
        borderRadius: 10,
        border: '0.5px solid rgba(200,168,75,0.35)',
        background: 'rgba(200,168,75,0.08)',
        fontSize: '0.82rem',
        color: 'rgba(255,255,255,0.75)',
        lineHeight: 1.55,
      }}
    >
      <strong style={{ color: C.gold }}>Textos provisionales.</strong> Los datos del titular y el contenido legal se muestran bajo la marca{' '}
      <strong style={{ color: '#fff' }}>DreamVinyl</strong> hasta disponer de la documentación jurídica definitiva (razón social, CIF y domicilio social completos).
    </div>
  );
}

export default function PageLegal({ tipo: tipoRaw, onBack, onNavigate, user }) {
  const tipo = VALID.has(tipoRaw) ? tipoRaw : 'aviso';
  const Body = BODIES[tipo];
  const title = TITLES[tipo];
  const [override, setOverride] = useState(null);
  const [ovLoading, setOvLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setOvLoading(true);
      try {
        const { data, error } = await supabase.from('app_config').select('value').eq('key', 'legal_overrides').maybeSingle();
        if (cancelled) return;
        if (error || !data?.value || typeof data.value !== 'object') {
          setOverride(null);
          return;
        }
        const block = data.value[tipo];
        const text = block && typeof block.text === 'string' ? block.text.trim() : '';
        if (!text) {
          setOverride(null);
          return;
        }
        setOverride({ replace: !!block.replace, text });
      } catch {
        if (!cancelled) setOverride(null);
      } finally {
        if (!cancelled) setOvLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [tipo]);

  return (
    <div style={{ background: '#0a0a0f', minHeight: '100vh', color: '#fff' }}>
      <WebTopBar onBack={onBack} title={title} mini dark user={user} onNavigate={onNavigate} onSignOut={onBack} />
      <article style={{ maxWidth: 700, margin: '0 auto', padding: '28px 20px 56px' }}>
        <h1 style={{ color: C.gold, fontSize: '1.45rem', fontWeight: 900, margin: '0 0 8px', letterSpacing: '-0.03em', lineHeight: 1.25 }}>
          {title}
        </h1>
        <p style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.45)', marginBottom: 22 }}>{SITE_CONFIG.nombre} · {SITE_CONFIG.dominio}</p>
        <LegalProvisionalNotice />
        <div style={{ fontSize: '0.9rem' }}>
          {ovLoading ? (
            <p style={{ color: 'rgba(255,255,255,0.45)' }}>Cargando…</p>
          ) : override?.text ? (
            <>
              {!override.replace ? <Body /> : null}
              {!override.replace ? <H3>Información adicional / actualizada</H3> : null}
              <div style={{ whiteSpace: 'pre-wrap', color: 'rgba(255,255,255,0.88)', lineHeight: 1.65 }}>{override.text}</div>
            </>
          ) : (
            <Body />
          )}
        </div>
      </article>
    </div>
  );
}
